import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

export default function Card({ children, size }) {
  return <Container size={size}>{children}</Container>;
}

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  size: PropTypes.number,
};

Card.defaultProps = {
  size: 100,
};
